import reduxThunk from 'redux-thunk'
import dataMoment from 'moment'
import localization from 'moment/locale/pt-br'

dataMoment.locale('pt-br', localization)

/**
 * construindo o middleware de logs para ativar o redux-logger
 */
const middleWareLogs = []
middleWareLogs.push(reduxThunk)
export { middleWareLogs }
